import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { Saseung3Component } from './saseung3.component';


const routes: Routes = [
  { path: '', component: Saseung3Component },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class Saseung3RoutingModule {}
